import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import { DayOffListParams } from '@/typings/api/index'

/**
 * **************************************休息日月份 **************************************
 */
// 根据月份查询休息日
export function getDayOffList(data?: DayOffListParams) {
  return request.post<AxiosResult>('/base/api/restday/listByMonth', data)
}
// 初始化休息日
export function resetDayOff(data?: DayOffListParams) {
  return request.post<AxiosResult>('/base/api/restday/reset', data)
}
// 设置休息日
export function saveDayOff(data?: DayOffListParams) {
  return request.post<AxiosResult>('/base/api/restday/save', data)
}
